<template>
    <button class="here-hide-btn" :class="{active: isActive}">
        <slot></slot>
    </button>
</template>
<script>
export default {
    name: 'HereButton',
    props: {
        isActive: {
            type: Boolean
        }
    }
}
</script>

<style scoped lang="scss">
.here-hide-btn {
    position: absolute;
    z-index: 999;
    bottom: 27px;
    right: 9px;
    width: 40px;
    height: 40px;
    background-color: #fff;
    border-radius: 6px;
    box-shadow: 0 0 5px #696868;

    &:hover {
        .here-hide-img {
            opacity: 1;
        }
    }

    .here-hide-img {
        width: 42px;
        height: 42px;
        opacity: 0.7;
    }
}

.active {
    background-color: #CFD0D3;

    .here-hide-img {
        opacity: 1;
    }
}
</style>
